import React from "react";
import Phone from "../phone/Phone";

import "./Main.scss";

function Main() {
  return (
    <main className="main">
      <Phone />
    </main>
  );
}

export default Main;
